module.exports = __webpack_public_path__ + "media/buy_report_icons/report-339bdb8a.svg";